import { render, staticRenderFns } from "./OfficialDashboard.vue?vue&type=template&id=08ad2de0"
import script from "./OfficialDashboard.vue?vue&type=script&lang=ts"
export * from "./OfficialDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports